<template>
  <v-footer
    color="#F0F0F0"
    padless
    height="100"
    app
    v-if="visible"
    dark
    absolute
  >
    <v-col
      class="text-center hidden-md-and-down"
      cols="12"
      xl="4"
      lg="4"
      md="12"
      sm="12"
    >
      <router-link class="routerLink" to="/"
        ><img
          src="../../assets/logo_text_black.svg"
          height="60"
          width="120"
          class="pt-4"
      /></router-link>
    </v-col>

    <v-col
      class="text-center hidden-sm-and-down"
      cols="12"
      xl="4"
      lg="4"
      md="12"
      sm="12"
    >
      <div>
        <router-link
          class="routerLink font-weight-bold mr-2"
          style="color: black; font-size: 16px; text-decoration: none"
          to="/company"
        >
          運営会社
        </router-link>
        <router-link
          class="routerLink font-weight-bold mr-2"
          style="color: black; font-size: 16px; text-decoration: none"
          to="/terms"
        >
          利用規約
        </router-link>
        <a
          class="routerLink font-weight-bold mr-2"
          style="color: black; font-size: 16px; text-decoration: none"
          href="https://respawn.jp/privacy-policy/"
          >個人情報の取り扱い</a
        >
        <router-link
          class="routerLink font-weight-bold mr-2"
          style="color: black; font-size: 16px; text-decoration: none"
          to="/inquiry"
        >
          お問い合わせ
        </router-link>
        <router-link
          class="routerLink font-weight-bold mr-2"
          style="color: black; font-size: 16px; text-decoration: none"
          to="/help"
        >
          ヘルプ
        </router-link>
      </div>
    </v-col>
    <v-col class="text-center" cols="12" xl="4" lg="4" md="12" sm="12">
      <div style="color: grey">
        &copy; {{ new Date().getFullYear() }} vla.tips All Rights Reserved
      </div>
    </v-col>
  </v-footer>
</template>
<script>
export default {
  name: "GlobalFooter",
  data() {
    return {
      visible: true,
      hide: [
        "login",
        "signup",
        "cooperateSignup",
        "signup_confirm",
        "signup_success",
        "thank_you",
        "password_reset",
        "password_reset_input",
        "password_reset_success",
        "password_reset_failed",
        "email_verifiy",
      ],
      baseUrl: process.env.VUE_APP_BASE_URL,
    };
  },
  mounted() {
    if (this.hide.includes(this.$route.name)) {
      return (this.visible = false);
    }
  },
};
</script>

<style>
</style>